import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaQuoteLeft, FaStar } from "react-icons/fa";
import "./clientReviews.css";

const reviews = [
    {
        name: "Pooja Shah",
        location: "Ahmedabad, Gujarat",
        review:
            "Our trip to Dwarka and Somnath was perfectly managed. Shivay Travels made everything smooth, safe, and joyful!",
        rating: 5,
    },
    {
        name: "Rakesh Mehta",
        location: "Surat, Gujarat",
        review:
            "Budget-friendly and comfortable. The driver was polite and the hotel arrangements were excellent.",
        rating: 4,
    },
    {
        name: "Neha Patel",
        location: "Vadodara, Gujarat",
        review:
            "I loved the quick booking experience and prompt WhatsApp updates. Highly recommend Shivay Tours!",
        rating: 5,
    },
];

const ClientReviews = () => {
    return (
        <section className="py-5 bg-light">
            <Container>
                <h2 className="text-center fw-bold mb-5 custom-heading">Client Reviews</h2>
                <Row className="gy-4">
                    {reviews.map((item, index) => (
                        <Col md={4} key={index}>
                            <Card className="h-100 shadow-sm border-0 review-card p-3">
                                <Card.Body>
                                    <FaQuoteLeft size={28} className="text-primary mb-3" />
                                    <Card.Text className="review-text mb-3">{item.review}</Card.Text>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <h6 className="mb-0 fw-bold">{item.name}</h6>
                                            <small className="text-muted">{item.location}</small>
                                        </div>
                                        <div>
                                            {[...Array(item.rating)].map((_, i) => (
                                                <FaStar key={i} className="text-warning" />
                                            ))}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default ClientReviews;
